import type { KeyboardEvent } from 'react'

export const blurOnEnterKeyUp = (evt: KeyboardEvent<HTMLInputElement>) => {
  try {
    if (['NumpadEnter', 'Enter'].includes(evt?.key)) {
      evt.currentTarget.blur()
    }
  } catch (err) {}
}
